// NOTE: This is the source of truth for what the latest version is.
export const SDK_VERSION = 'v5';

export const VERSION_DELIMITER = '-';
export const DEFAULT_PUBLIC_API_VERSION = 'v1';
export const DEFAULT_PRIVATE_API_VERSION = 'v1';
export const DEFAULT_VERSION = `${DEFAULT_PRIVATE_API_VERSION}${VERSION_DELIMITER}${DEFAULT_PUBLIC_API_VERSION}`;
